const state = {
  status: 'loading',
  error: null,
  data: []
};

export default state;
